<template>
  <button
    type="button"
    class="w-full text-left p-3 rounded-lg border border-gray-200 hover:bg-gray-50 transition-colors cursor-pointer"
    @click="$emit('click')"
  >
    <div class="flex items-center justify-between mb-1">
      <span class="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium" :class="statusClass">
        {{ statusLabel }}
      </span>
      <span class="text-xs text-gray-500">{{ formattedDate }}</span>
    </div>
    <p v-if="authorName" class="text-sm font-medium text-gray-900 truncate">{{ authorName }}</p>
    <p class="text-sm text-gray-500 truncate">{{ bodyPreview }}</p>
    <p v-if="waitingSinceLabel" class="text-xs text-orange-600 mt-1">
      {{ waitingSinceLabel }}
    </p>
  </button>
</template>

<script>
import { useI18n } from "vue-i18n";

export default {
  name: "IntercomConversationCard",

  emits: ["click"],

  props: {
    conversation: {
      type: Object,
      required: true,
    },
  },

  setup() {
    const { t, locale } = useI18n();
    return { t, locale };
  },

  computed: {
    statusClass() {
      const state = this.conversation.state;
      if (state === "open") return "bg-green-100 text-green-800";
      if (state === "snoozed") return "bg-orange-100 text-orange-800";
      return "bg-gray-100 text-gray-800";
    },

    statusLabel() {
      const state = this.conversation.state;
      if (state === "open") return this.t("open");
      if (state === "snoozed") return this.t("snoozed");
      return this.t("closed");
    },

    formattedDate() {
      if (!this.conversation.createdAt) return "";
      return new Date(this.conversation.createdAt).toLocaleDateString(this.locale);
    },

    authorName() {
      return this.conversation.source?.author?.name;
    },

    bodyPreview() {
      const body = this.conversation.source?.body;
      if (!body) return "";
      const parser = new DOMParser();
      const doc = parser.parseFromString(body, "text/html");
      const text = doc.body.textContent || "";
      return text.length > 100 ? text.slice(0, 100) + "…" : text;
    },

    waitingSinceLabel() {
      if (!this.conversation.waitingSince) return null;
      const date = new Date(this.conversation.waitingSince);
      return this.t("waiting_since", { date: date.toLocaleDateString(this.locale) });
    },
  },
};
</script>

<i18n src="./IntercomConversationCard.i18n.json"></i18n>
